// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"e41b76b8","453":"5592e192"}[chunkId] + ".chunk.js";
};